<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="display-kss-results-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog  modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header title text-center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h5 class="modal-title" id="myModalLabel" >Your Performance</h5>
        </div>
     <div class="row mt-2">
                <div class="col-lg-11 col-11 mx-auto">
                    <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                                    style="background: url('/assets/images/focus-bg-pexels-jonas-svidras-759960.png')  center;">
                                    <h3 class="widget-user-username text-left">Eliminate Self-Sabotage.</h3>
                                    <h2 class="widget-user-desc text-right">For Version 2.0 of You.</h2>
                                    <h3 class="widget-user-username text-right">Focus and Evolve.</h3>
                                </div>
                                <div class="widget-user-image">
                                    <img class="img-circle" src="/assets/images/focus-pexels-bahaa-a-shawqi-583437-132x132.jpg" alt="User Avatar">
                                </div>
                    </div>
                </div>
        </div>
 <!-- Modal -->

         <h6 class="modal-title card text-center" id="myModalLabel" v-html="'Your Performance for Goal:&nbsp;<b>' + kssdata.name +'</b><br/><small><i>'+ kssdata.description+'</i></small>'" ></h6>

        <div class=" content modal-body "><!-- embed-responsive-16by9 -->
            <!-- <div class="row d-flex justify-content-between bg-primary" >
                <div class="col-5 card p-2 mb-2 bg-primary" v-for="component in actionhabitdata.components" :key="component.id">
                    <small>{{component.name}}: <br/>({{component.description}}.)</small>
                </div>
            </div> -->

            <div class="card mx-auto" style="background: #fff; border:3px solid #fff;">
                <h6 class="text-center"  >Overall Focus Performance: </h6>
            </div>


            <div  class="card" style="background: #e8f2e3;" v-if="kssdata != ''">
                <table class="table table-striped table-dark table-bordered">
                    <tbody>
                    <tr><td class="table-headings-border" colspan="2" style="text-align:center;color:rgb(61, 61, 234);">My Focus Streaks (last Month):</td></tr>
                    <tr v-for="(trak, index) in ksstrakkerdata" :key="index" >
                        <td >Streak: {{trak.streak}}: {{formatDateShort(trak.created_at)}} - {{formatDateShort( trak.updated_at )}}</td> <td  v-html="getStreakStars(trak.streak)"></td>
                    </tr>
                    <tr v-if="ksstrakkerdata==''"> <td colspan="2">No Streaks to display as yet</td></tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
import axios from 'axios';
import Errors from '../../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
export default {
    components: { Errors, },
    name: "ActionHabitResultsModal",
    data() {
        return {
            userdata:[],
            currentkssid:'',
            kssdata:[],
            ksstrakkerdata:'',
            errors: {
                        nahme: '',
                        message: '',
                    },
            allhabitsdata:[],



        }
    },
    props: {
        user:'',
        habits:[],
        habitpoints:[],
        forkss:'',
    },
    mounted() {
        // console.error("ActionHabitResultsModal mounted...");
        EventBus.$on('displayKSSResultsModal', (data) => {
            console.error("displayKSSResultsModal show fired...");
            this.userdata = data.userdata;
 console.error(this.userdata);
            this.kssdata = data.kssdata;
 console.error(this.kssdata);
            this.ksstrakkerdata = data.ksstrakkerdata;
 console.error(this.ksstrakkerdata);

            $('div#display-kss-results-modal').modal('show');
        });
    },
    methods: {
        formatDateShort(dateString) {
                const date = new Date(dateString);
                const formattedDate =  date.toLocaleDateString('en', {
                day: '2-digit',
                month: 'short'
                });
                // console.error(formattedDate);
                return formattedDate;
            },
        randomizeCelebrationImages(){
            const array = ['rugby-yay.gif', 'fireworks_banner.gif'];
                const randomIndex = Math.floor(Math.random() * array.length);
            return array[randomIndex];
        },
        getStreakStars(streak) {
            const numStars = Math.floor(streak / 10);
            const starHtmlString = `<img src='/images/yays/yellow-gold-star85.png'>`;
            var finalHtml = '';
            if(numStars < 5) {
                for(var i=1; i<=numStars; i++) {
                    finalHtml +=starHtmlString;
                }
            } else {
                var image = this.randomizeCelebrationImages();
                finalHtml += `<h4>`+numStars + ' stars! '+ `<img style="width:200px;" class="yayimage" src='/images/yays/${image}'></h4>`;
            }
            return finalHtml;
        },

         formattDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        },

        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
            // // usage example:
            // var a = ['a', 1, 'a', 2, '1'];
            // var unique = a.filter(onlyUnique);
        },

        daysInYear(year) {
            return ((year % 4 === 0 && year % 100 > 0) || year %400 == 0) ? 366 : 365;
        },

        cancel() {
            this.kssdata = '';
            this.ksstrakkerdata = '';
            $('div#isplay-kss-results-modal').modal('hide');
        },

        disableClickedButton(compid) {
            document.getElementById(compid).disbled = true;
        },

        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed:{


    }
}
</script>

<style scoped>
.content-box-blue .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #265cb5;
}
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
med-small{
 font-size: x-small;
}
tiny{
    font-size: xx-small;
}
.yayimage {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  animation: fadeOut 5s forwards;
}

</style>
